"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var className = function className(props) {
  return (0, _classnames.default)('FormGroup', {
    'FormGroup--large-margin': props.separated
  }, props.className);
};

var FormGroup = function FormGroup(props) {
  var children = props.children,
      style = props.style,
      error = props.error;
  return _react.default.createElement("div", {
    className: className(props),
    style: style
  }, _react.default.Children.map(children, function (child, key) {
    return error == null ? _react.default.cloneElement(child, {
      key: key
    }) : _react.default.cloneElement(child, {
      key: key,
      error: error
    });
  }));
};

var _default = FormGroup;
exports.default = _default;